__turbopack_context__.v({
  "icon": "index-module-scss-module__L8NQ3a__icon",
});
